import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

// ============================================
// Response Types
// ============================================

export interface NigerianKycResponse {
  kyc: any
  verificationResult: {
    success: boolean
    status: 'approved' | 'rejected' | 'pending'
    message: string
    details?: {
      dataMatched?: boolean
      selfieMatched?: boolean
      selfieConfidence?: number
      validationMessages?: string
    }
  }
}

export interface LivenessTokenResponse {
  success: boolean
  token?: string
  sessionId?: string
  message?: string
}

// ============================================
// Request Types
// ============================================

export interface GenerateLivenessTokenRequest {
  firstName?: string
  lastName?: string
  email?: string
}

// ============================================
// API Slice
// ============================================

export const kycSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    // Get user's KYC submissions
    getKycs: build.query<any, void>({
      query: () => `${urlConfig.kycUrl}/kyc/user`,
      providesTags: ['Kyc'],
    }),

    // Submit generic KYC (manual verification)
    submitKyc: build.mutation<{}, FormData>({
      query: body => {
        return {
          url: `${urlConfig.kycUrl}/kyc`,
          method: 'POST',
          body,
        }
      },
      invalidatesTags: ['Kyc'],
    }),

    // Submit Nigerian KYC (automated verification)
    submitNigerianKyc: build.mutation<NigerianKycResponse, FormData>({
      query: body => ({
        url: `${urlConfig.kycUrl}/kyc/ng/verify`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Kyc'],
    }),

    // Generate liveness token for Youverify SDK
    generateLivenessToken: build.mutation<
      LivenessTokenResponse,
      GenerateLivenessTokenRequest | void
    >({
      query: body => ({
        url: `${urlConfig.kycUrl}/kyc/ng/liveness-token`,
        method: 'POST',
        body: body || {},
      }),
    }),
  }),
})

export const {
  useGetKycsQuery,
  useSubmitKycMutation,
  useSubmitNigerianKycMutation,
  useGenerateLivenessTokenMutation,
} = kycSlice
